import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
const TOTAL_SECONDS = 22 * 60 + 22;
function useCountdown(initialSeconds: number) {
  const [seconds, setSeconds] = useState(initialSeconds);
  useEffect(() => {
    const id = setInterval(() => setSeconds(s => s > 0 ? s - 1 : 0), 1000);
    return () => clearInterval(id);
  }, []);
  return {
    mm: Math.floor(seconds / 60),
    ss: seconds % 60
  };
}
function Unit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <span className="inline-flex items-baseline gap-1" data-id="element-135" data-mp="k293vls82qvj">
      <span className="font-display text-xl font-bold tabular-nums text-gold sm:text-2xl" data-id="element-136" data-mp="k3slpgtj19zf">{String(value).padStart(2, '0')}</span>
      <span className="text-[10px] font-bold uppercase tracking-widest text-fog/60" data-id="element-137" data-mp="abmui9b3mwla">{label}</span>
    </span>;
}
export function OfferBar() {
  const {
    mm,
    ss
  } = useCountdown(TOTAL_SECONDS);
  return <div role="region" aria-label="Offer countdown" className="fixed inset-x-0 top-0 z-50 h-12 border-b border-gold/40 bg-ink-2/95 backdrop-blur" data-id="element-138" data-mp="1bzunry0pyuc">
      <div className="mx-auto flex h-full max-w-5xl items-center justify-center gap-4 px-4 sm:gap-6" style={{
      paddingBottom: "6px"
    }} data-id="element-139" data-mp="qxii8zt07azs">
        <p className="flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.2em] text-fog sm:text-sm" data-id="element-140" data-mp="10x99msm9p9vn">
          <HourglassIcon className="h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-141" data-mp="vy4z9ynlx63q" />
          Offer ends in:
        </p>
        <p className="flex items-baseline gap-1.5" data-id="element-142" data-mp="89dgfxvwq03m">
          <Unit value={mm} label="Min" data-id="element-143" data-mp="3a0wbkwf774q" />
          <span className="font-display text-lg font-bold text-teal" data-id="element-144" data-mp="3b249gi53di8">:</span>
          <Unit value={ss} label="Sec" data-id="element-145" data-mp="hywzb3jmdtyh" />
        </p>
      </div>
    </div>;
}